import {
  
  formatIncompletePhoneNumber,
} from "libphonenumber-js";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { isNullOrEmpty } from "../config/ENV";

export const PhoneNumberUtility = {};

export function isValidPhoneNumber(phoneNumber, countryCode) {
  try {
    let formattedCountryCode = "+" + countryCode;
    const formattedPhoneNumber = `${formattedCountryCode}${phoneNumber}`;
    // Parse the phone number using libphonenumber-js
    const parsedPhoneNumber = parsePhoneNumberFromString(formattedPhoneNumber);
    // Check if the phone number is valid
    return parsedPhoneNumber && parsedPhoneNumber.isValid();
  } catch (e) {
    console.log(e);
    return false;
  }
}

export function formatPhoneNumberByUsingCountryCode(phoneNumber, countryCode) {
  try {
    let formattedCountryCode = "+" + countryCode;
    const parsedNumber = parsePhoneNumberFromString(
      `${formattedCountryCode}${phoneNumber}`
    );
    return parsedNumber ? parsedNumber.formatNational() : "";
  } catch (e) {
    console.log(e);
    return "";
  }
}

export function getFormattedPhoneNumber(phoneNumber, countryCode) {
  try {
    let formattedCountryCode = "+" + countryCode;
    let formattedPhoneNumber = "";
    if (!isNullOrEmpty(phoneNumber) && !isNullOrEmpty(countryCode)) {
      formattedPhoneNumber =
        formattedCountryCode +
        " " +
        formatPhoneNumberByUsingCountryCode(phoneNumber, countryCode);
    } else if (!isNullOrEmpty(phoneNumber) && isNullOrEmpty(countryCode)) {
      formattedPhoneNumber = formatPhoneNumberByUsingCountryCode(
        phoneNumber,
        countryCode
      );
    }
    return formattedPhoneNumber;
  } catch (e) {
    console.log(e);
    return "";
  }
}

export function getPhoneNumberByCountryCode(phoneNumber, countryCode) {
  try {
    return formatIncompletePhoneNumber(phoneNumber, countryCode);
  } catch (e) {
    console.log(e);
    return phoneNumber;
  }
}


export function validatePhoneNumber(phoneNumberString, dialCode) {
  let formattedMobileNumber=dialCode+""+phoneNumberString; 
  const phoneNumber = parsePhoneNumberFromString(formattedMobileNumber, dialCode);
  return phoneNumber ? phoneNumber.isValid() : false;
}

export function formattedMobileNumber(mobileNumber){
  let countryCode='';
  let _mobileNumber='';
  if(!isNullOrEmpty(mobileNumber)){
    if(hasSpecialCharacters(mobileNumber)){
      countryCode = mobileNumber.split('-')[0];
      let mobileNo=mobileNumber.slice(countryCode.length).replace(/\D/g, '');
      _mobileNumber=getFormattedPhoneNumber(mobileNo,countryCode);
   }else{
     _mobileNumber="+1 "+mobileNumber
   }
  }
  return _mobileNumber;

}

export function hasSpecialCharacters(str) {
  return /[^\w\s]/gi.test(str);
}

export function getCountryCodefromMobile(mobileNumber) {
  let countryCode='';
  if(hasSpecialCharacters(mobileNumber)){
    countryCode = mobileNumber.split('-')[0];
  }else{
    countryCode="1"
  }
  return countryCode;
}

export function getMobileNumberCountryCode(mobileNumber) {
  let countryCode='';
  let _mobileNumber='';
  if(hasSpecialCharacters(mobileNumber)){
     countryCode = mobileNumber.split('-')[0];
     let mobileNo=mobileNumber.slice(countryCode.length).replace(/\D/g, '');
     _mobileNumber=mobileNo;
  }else{
    _mobileNumber=mobileNumber;
  }

  return _mobileNumber;
}
